import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

const EditMaterialModal = ({ isOpen, material, categories, onClose, onUpdate }) => {
    // Initialize editMaterial with a fallback object to avoid undefined errors
    const [editMaterial, setEditMaterial] = useState(() => material || { displayName: "", categoryID: "", display: false });

    // Update editMaterial whenever the 'material' prop changes
    useEffect(() => {
        if (material) {
            setEditMaterial({
                materialID: material.materialsID,
                displayName: material.displayName || "",
                categoryID: material.categoryID || "",
                materialType: material.materialType || "",
                display: material.display || false,
            });
        }
    }, [material]);

    // If modal isn't open, we don't render it, but hooks are still called
    if (!isOpen) return null;

    const handleSave = () => {
        if (!editMaterial.displayName || !editMaterial.categoryID) {
            alert("Please fill out all required fields.");
            return;
        }
        onUpdate(editMaterial); // Call the update function
        onClose(); // Close the modal
    };

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Edit Material</h3>
                    <button className="close-button" onClick={onClose}>✕</button>
                </div>

                <div className="modal-body">
                    {/* Display Name */}
                    <div className="form-group">
                        <label>Display Name</label>
                        <input
                            type="text"
                            className="filterInput"
                            placeholder="Display Name"
                            value={editMaterial.displayName}
                            onChange={(e) =>
                                setEditMaterial({
                                    ...editMaterial,
                                    displayName: e.target.value,
                                })
                            }
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Material Type</label>
                        <select
                            className="filterInput"
                            value={editMaterial.materialType || ""}
                            onChange={(e) => {
                                setEditMaterial({
                                    ...editMaterial,
                                    materialType: e.target.value,
                                });
                            }
                            }
                            required
                        >
                            <option value="">Material Type</option>
                            <option value="POLICY">Policy</option>
                            <option value="AGENT">Agent</option>
                        </select>
                    </div>

                    {/* Category Selection */}
                    <div className="form-group">
                        <label>Category</label>
                        <select
                            className="filterInput"
                            value={editMaterial.categoryID || ""}
                            onChange={(e) =>
                                setEditMaterial({
                                    ...editMaterial,
                                    categoryID: parseInt(e.target.value),
                                })
                            }
                            required
                        >
                            <option value="">Select Category</option>
                            {categories.map((cat) => (
                                <option key={cat.categoryID} value={cat.categoryID}>
                                    {cat.categoryName}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Display Checkbox */}
                    <div className="form-group">
                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                checked={editMaterial.display || false}
                                onChange={(e) =>
                                    setEditMaterial({
                                        ...editMaterial,
                                        display: e.target.checked,
                                    })
                                }
                            />
                            Display?
                        </label>
                    </div>

                    {/* Actions */}
                    <div className="modal-actions">
                        <button className="baseButton" onClick={handleSave}>
                            Save Changes
                        </button>
                        <button className="baseButton secondary" onClick={onClose}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body // Render the modal into the body element
    );
};

export default EditMaterialModal;
